import React from 'react'
import './ExpireTrialModal.scoped.sass'

import { Button } from '@/components/Button/Button'
import modalService from '@/services/modal.service'

import { UpgradeSubscriptionModal } from '../../SettingsPage/SettingsArea/SettingsAreaBilling/components/UpgradeSubscriptionModal/UpgradeSubscriptionModal.jsx'
import { ReactComponent as HeaderSVG } from '@/assets/svg/modals/header-wave-1.svg'

const ExpireTrialModal = () => {
  return (
    <div className='main-container'>
      <div className='header-img'><HeaderSVG /></div>
      <div className='header'>
        Your trial period will expire in 3 days!
      </div>
      <div className='body'>
        Your trial Boxes period it's above to end in 3 days. Do you want to buy a Boxes plan?
      </div>
      <div className='bottom'>
        <div className='cancel-button'>
          <Button content='Cancel' type='secondary' click={() => modalService.close()} />
        </div>
        <div className='next-button'>
          <Button content='Continue' click={() => modalService.open(<UpgradeSubscriptionModal />)} />
        </div>
      </div>
    </div>
  )
}

export default ExpireTrialModal
